module.exports = __webpack_public_path__ + "img/three_single_select.65879feb.png";